import React, { useRef, useContext } from 'react';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useTranslation } from 'react-i18next';
import IconButton from '../../../Button/IconButton';
import UploadIcon from '@wix/da-ds/pkg/Icons/24x24/Upload';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import { useFileUpload } from '../../_hocs/withFileUpload';
import { useVerification } from '../../../VerificationPopup/withVerification';
import { MIME_CONFIG } from '../../../utils/mime';

export type Props = {
  className?: string;
};

const UploadButton: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { allowMultipleUploads, uploadFiles } = useFileUpload();
  const { isVerificationNeeded, pushVerificationPopup } = useVerification();
  const fileInput = useRef<HTMLInputElement>(null);

  const chooseFile = () => {
    if (isVerificationNeeded) {
      pushVerificationPopup('submit');
      return;
    }

    if (fileInput.current) {
      fileInput.current.value = '';
      fileInput.current.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from<File>(e.target.files || []);
    if (!files || files.length < 1) {
      return;
    }
    uploadFiles(files.map(file => ({ file })));
  };

  return (
    <>
      {isMobile && (
        <IconButton className={'astro'} onClick={chooseFile}>
          <UploadIcon withPadding size={IconSize.MEDIUM} />
        </IconButton>
      )}

      {!isMobile && (
        <GhostButton
          variant="main"
          size="large"
          onClick={chooseFile}
          className={className}
        >
          {t('mediapopup.upload')}
        </GhostButton>
      )}

      <input
        type="file"
        ref={fileInput}
        onChange={handleFileChange}
        accept={MIME_CONFIG.forMediaManager.join()}
        style={{ display: 'none' }}
        multiple={!!allowMultipleUploads}
      />
    </>
  );
};

export default UploadButton;
